import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AttendanceProjectType } from '../../Types/HeyTraderTypes/Attendances/AttendanceProjectType';
import { getAttendanceProjectNew } from '../../Thunks/NewAttendanceThunks';

interface NewAttendanceProjectSliceState {
  loader: boolean; // for refres pages and inital loadings
  attendanceProjectList: AttendanceProjectType[];
  errorDisplay: string | null;
}

// set inital valus
const initialState: NewAttendanceProjectSliceState = {
  loader: false,
  attendanceProjectList: [],
  errorDisplay: '',
}

// set state valu for api response
const newAttendanceProjectSlice = createSlice({
  name: 'newAttendanceProjectSlice',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      .addCase(getAttendanceProjectNew.rejected, (state, action) => {
        state.loader = false;
        state.errorDisplay = action.error.message!;
      })

      .addCase(getAttendanceProjectNew.pending, state => {
        state.loader = true;
        state.errorDisplay = null;
      })

      .addCase(getAttendanceProjectNew.fulfilled, (state, action: PayloadAction<AttendanceProjectType[]>) => {
        state.loader = false;
        state.attendanceProjectList = action.payload;
      })
  }
})

export const { } = newAttendanceProjectSlice.actions
export default newAttendanceProjectSlice.reducer
